import {createModel} from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";
import {
    ProSkillManagerAssessmentStatusType
} from "~~/package/mapper/proSkillManager/model/assessment/ProSkillManagerAssessmentStatusType";
import { UserStatusType } from "~~/package/mapper/user/model/UserStatusType";

export class ProSkillAssureAssessmentInfoModel extends Model {
    constructor(
        public assessmentId: number = 0,
        public assessmentTitle: string = "",
        public assessmentStatus: ProSkillManagerAssessmentStatusType = ProSkillManagerAssessmentStatusType.LIVE,
        public authorName: string = "",
        public createdAt: string = "",
        public userStatus: UserStatusType = UserStatusType.NORMAL,
        public reportLangs: string[] = []
    ) {
        super();
    }

    public static create(model: Partial<ProSkillAssureAssessmentInfoModel>): ProSkillAssureAssessmentInfoModel {
        return createModel<ProSkillAssureAssessmentInfoModel>(ProSkillAssureAssessmentInfoModel, {
            ...model
        });
    }
}
